import { components } from "@/lib/ApiSchema";
import AttachFiles from "@/lib/AttachFiles";
import Button from "@/lib/Button";
import Input from "@/lib/Input";
import {
  // useAddOrganization,
  useFetchContacts,
  useFetchOrganizations,
} from "@/lib/queries/hooks";
import $api from "@/lib/queries/openapi";
import useUploadFiles from "@/lib/queries/useUploadFiles";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router";
import Select, { SingleValue } from "react-select";

export default function CreateRFQ({ done }: { done: () => void }) {
  const { teamSlug } = useParams();
  // const addOrganization = useAddOrganization();
  // const [addingOrg, setAddingOrg] = useState(false);
  // const [addingOrgName, setAddingOrgName] = useState("");
  // const [addingOrgDomain, setAddingOrgDomain] = useState("");
  const [note, setNote] = useState("");
  // const [addingContact, setAddingContact] = useState(false);
  // const [addingContactName, setAddingContactName] = useState("");
  // const [addingContactEmail, setAddingContactEmail] = useState("");
  const { uploadFiles, isUploading, fileIds, files, setFiles } = useUploadFiles(
    {},
  );

  const queryClient = useQueryClient();
  const { mutate } = $api.useMutation("post", "/api/teams/{team_slug}/rfqs", {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get", "/api/teams/{team_slug}/rfqs"],
      });
      done();
    },
  });

  const organizations = useFetchOrganizations("");
  const contacts = useFetchContacts();

  const orgOptions = organizations.data?.map((org) => ({
    label: `${org.name}<${org.email_domain}>`,
    value: org,
  }));
  const [selectedOrg, setSelectedOrg] = useState<
    SingleValue<{
      label: string;
      value: components["schemas"]["OrganizationSchema"];
    }>
  >();
  const contactOptions = contacts
    .filter(({ organization }) => organization.id === selectedOrg?.value.id)
    .map((contact) => ({
      label: `${contact.name}<${contact.email}>`,
      value: contact.id,
    }));
  const [selectedContact, setSelectedContact] =
    useState<SingleValue<{ label: string; value: string }>>();

  return (
    <div className="h-[90vh] max-h-[900px] w-[90vw] max-w-[900px] bg-white py-10 px-14 flex flex-col gap-8 ">
      <div className="font-bold text-xl">Create RFQ</div>
      <div className="grow flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <div>Organization</div>
          <div className="flex gap-2">
            <Select
              options={orgOptions}
              onChange={(option) => setSelectedOrg(option)}
              value={selectedOrg}
              className="grow"
            />
            {/* <Button onClick={() => setAddingOrg(true)} disabled={addingOrg}>
              Add Organization
            </Button> */}
          </div>
          {/* {addingOrg && (
            <div className="flex gap-8 items-end">
              <Input
                label="Name"
                value={addingOrgName}
                onChange={setAddingOrgName}
              />
              <Input
                label="Domain"
                value={addingOrgDomain}
                onChange={setAddingOrgDomain}
              />
              <Button onClick={() => setAddingOrg(false)}>Cancel</Button>
              <Button
                primary
                onClick={() =>
                  addOrganization({
                    name: addingOrgName,
                    email_domain: addingOrgDomain,
                    accounting_system_organization_id: null,
                  })
                }
                disabled={!addingOrgName || !addingOrgDomain}
              >
                Add
              </Button>
            </div>
          )} */}
        </div>
        {selectedOrg && (
          <div className="flex flex-col gap-2">
            <div>Contact</div>
            <div className="flex gap-2">
              <Select
                options={contactOptions}
                onChange={(option) => setSelectedContact(option)}
                value={selectedContact}
                className="grow"
              />
              {/* <Button
                onClick={() => setAddingContact(true)}
                disabled={addingContact}
              >
                Add Contact
              </Button> */}
            </div>
            {/* {addingContact && (
              <div className="flex gap-8 items-end">
                <Input
                  label="Name"
                  value={addingContactName}
                  onChange={setAddingContactName}
                />
                <Input
                  label="Email"
                  value={addingContactEmail}
                  onChange={setAddingContactEmail}
                />
                <Button onClick={() => setAddingContact(false)}>Cancel</Button>
                <Button
                  primary
                  onClick={() => {
                    // addContact({
                    //   name: addingContactName,
                    //   email: addingContactEmail,
                    //   organization: selectedOrg.value.id,
                    // });
                  }}
                  disabled={!addingContactName || !addingContactEmail}
                >
                  Add
                </Button>
              </div>
            )} */}
          </div>
        )}
        <Input label="Note" value={note} onChange={setNote} rows={5} />
        <AttachFiles
          files={files}
          setFiles={(files) => {
            setFiles(files);
            uploadFiles(files);
          }}
        />
      </div>
      <div className="w-full flex gap-2 justify-between items-center px-3 py-1">
        <Button onClick={done} className="border">
          Close
        </Button>
        <Button
          primary
          loading={isUploading}
          onClick={() => {
            mutate({
              params: {
                path: {
                  team_slug: teamSlug!,
                },
              },
              body: {
                contact_id: selectedContact?.value ?? "",
                note: note ? note : undefined,
                file_ids: fileIds,
              },
            });
          }}
          disabled={!selectedContact?.value}
        >
          Create
        </Button>
      </div>
    </div>
  );
}
